import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { combineStates, siteSettingsState } from '../../../store';
import { connect } from 'react-redux';
import { translate } from '../../../services';
export class emailComponent extends Component {
 
  openmail = () => {
    const data = this.props.siteSettings;
    const emailTo = data.emailToConfiguration.emailTo;
    const cc = data.emailToConfiguration.cc;
    const emailSub = translate ( 'EMAILSUBJECT' ) || data.emailToConfiguration.subject;
    const body = ( translate ( 'EMAILBODY' ) || data.emailToConfiguration.body ) + window.location.href;
    //if user needs to have cc in mailto below condition will work
    if(cc !== ""){
    window.open( "mailto:"+emailTo+'?cc='+emailTo+'&subject='+emailSub+'&body='+body );
    }else{
    window.open( "mailto:"+emailTo+'?subject='+emailSub+'&body='+body );
    }
  }
  render() {
    return <div className="support">
      <div className="header">
        <div className="header-line"></div>
        <span>{translate("Support")}</span>
      </div>
        <p className="content"><p className='popup-text'>{ translate ('EMAILPOPUPTEXT') }</p>
          <a className= "mail"  onClick = {this.openmail}> 
            { this.props.siteSettings.emailToConfiguration.emailTo }
          </a>
        </p>
        </div>
  }
}
emailComponent.propTypes = {
  siteSettings: PropTypes.shape( {
  emailToConfiguration: PropTypes.shape( {
    emailTo: PropTypes.string,
    subject: PropTypes.string,
    copyTo: PropTypes.string
  } )
} )
}

export const Email = connect( combineStates(  siteSettingsState )) (emailComponent) ;